export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  ENDPOINTS: {
    LICITACIONES: {
      LISTAR_LICITACIONES: '/licitaciones/listar-licitaciones',
      ESTADOS_MP: '/licitaciones/estados-licitaciones-mercadopublico',
      ESTADOS: '/licitaciones/estados-licitaciones',
      ACTUALIZAR_ESTADO: '/licitaciones/actualizar-estado',
      DETALLE: (codigoExterno: string) => `/licitaciones/${codigoExterno}/detalle-licitacion`,
      MARCAR_VISTO: (licitacionId: number) => `/licitaciones/licitaciones/${licitacionId}/visto`,
      POSTULAR: (licitacionId: string | number) => `/licitaciones/postulada/${licitacionId}`,
      ADJUDICAR: (licitacionId: string | number) => `/licitaciones/adjudicada/${licitacionId}`,
      MENSAJES: (licitacionId: number) => `/licitaciones/${licitacionId}/mensajes`,
      CREAR_MENSAJE: (licitacionId: number) => `/licitaciones/${licitacionId}/mensaje`,
      ELIMINAR_MENSAJE: (mensajeId: string) => `/licitaciones/mensaje/${mensajeId}`,
      DESCARGAR_ARCHIVO: (archivoId: number) => `/licitaciones/archivos/${archivoId}/descargar`,
      DESCARGAR_ARCHIVO_LINK: (archivoId: number) => `/licitaciones/archivos/${archivoId}/descargar-link`,
      SUBIR_ADJUNTOS_MANUAL: (codigoExterno: string) => `/celery/${codigoExterno}/subir-adjuntos-manual`,
      ANALIZAR_DOCUMENTOS: (codigoExterno: string) => `/celery/${codigoExterno}/analizar-documentos`,
    },
    COMPRAS_AGILES: {
      LISTAR: '/compras_agiles/listar-compras-agiles',
      DETALLE: (codigoExterno: string) => `/compras_agiles/${codigoExterno}/detalle-compra-agil`,
      ACTUALIZAR_ESTADO: '/compras_agiles/actualizar-estado-compra-agil',
      POSTULAR: (compraAgilId: string | number) => `/compras_agiles/postulada/${compraAgilId}`,
      ADJUDICAR: (compraAgilId: string | number) => `/compras_agiles/adjudicada/${compraAgilId}`,
      MENSAJES: (compraAgilId: number) => `/compras_agiles/${compraAgilId}/mensajes`,
      CREAR_MENSAJE: (compraAgilId: number) => `/compras_agiles/${compraAgilId}/mensaje`,
      ELIMINAR_MENSAJE: (mensajeId: string) => `/compras_agiles/mensaje/${mensajeId}`,
      MARCAR_VISTO: (compraAgilId: number) => `/compras_agiles/${compraAgilId}/visto`
    },
    NOTIFICACIONES: {
      LISTAR: '/notificaciones/listar-alertas',
      MODIFICAR_ESTADO: (alertaId: string) => `/notificaciones/${alertaId}/modificar-estado-alerta`,
    },
    SCRAPER: {
      INFO: '/celery/scraper_info'
    },
    USUARIOS: {
      OBTENER_USUARIO: '/usuarios/usuario',
      EDITAR_USUARIO: '/usuarios/editar_usuario',
      CAMBIAR_CONTRASENA: '/usuarios/cambiar-contrasena'
    }
  }
} as const; 